import * as React from 'react'
import {Splitter} from "../../../../util/table-splitter-ui/src/components/Splitters/Splitter";
import {TransportOrderTable} from "../../transportOrders/TransportOrderTable";
import AceEditor from "react-ace";
import {Button, Icon} from "semantic-ui-react";
import {LogView} from "../../logView/LogView";
import {ConfigContext} from "../../../context/ConfigContext";
import {MultiOrderScriptResultCompareModal} from "./MultiOrderScriptResultCompareModal";
import {IfBox} from "../../../../style/if";

export interface MultiOrderScriptResultProps {
    xRequestId
    originalOrders
}

export interface MultiOrderScriptResultState {
    selectedResult: string
    showCompareModal: boolean
    topHeight: number
    isDragging: boolean
}

export class MultiOrderScriptResult extends React.Component<MultiOrderScriptResultProps, MultiOrderScriptResultState> {

    static contextType = ConfigContext
    context!: React.ContextType<typeof ConfigContext>;

    containerRef = React.createRef<HTMLDivElement>();

    constructor(props) {
        super(props)

        this.state = {
            selectedResult: "",
            showCompareModal: false,
            topHeight: 0,
            isDragging: false,
        }
    }

    componentDidMount() {
        requestAnimationFrame(() => {
            if (this.containerRef.current) {
                this.setState({ topHeight: Math.round(this.containerRef.current.clientHeight * 0.67) })
            }
        })
    }

    componentWillUnmount() {
        document.removeEventListener('mousemove', this.onDragMove);
        document.removeEventListener('mouseup', this.onDragEnd);
    }

    onDragStart = (e: React.MouseEvent) => {
        e.preventDefault();
        this.setState({ isDragging: true });
        document.addEventListener('mousemove', this.onDragMove);
        document.addEventListener('mouseup', this.onDragEnd);
    }

    onDragMove = (e: MouseEvent) => {
        if (!this.containerRef.current) return;
        const rect = this.containerRef.current.getBoundingClientRect();
        const newTop = e.clientY - rect.top;
        this.setState({ topHeight: Math.max(150, Math.min(rect.height - 100, newTop)) });
    }

    onDragEnd = () => {
        this.setState({ isDragging: false });
        document.removeEventListener('mousemove', this.onDragMove);
        document.removeEventListener('mouseup', this.onDragEnd);
    }

    drawTable() {
        return <>
            <TransportOrderTable
                transportOrders={this.context.multiOrderScriptResults}
                transportOrderAmount={this.context.multiOrderScriptResults?.length}
                selectedOrderChanged={(newSelectedOrder) => { this.setState({ selectedResult: JSON.stringify(newSelectedOrder, null, 4) }) }}
                selectedOrderIdsChanged={() => { }}
                reload={() => { }}
                initialPageSize={20}
                preSelectedTransportOrderIds={[]}
            />
        </>
    }

    drawSingleResultJson() {
        return <>
            <Button
                icon
                disabled={this.state.selectedResult == ""}
                onClick={(evt) => {
                    this.setState({
                        showCompareModal: true
                    })
                }}>
                <Icon name='exchange' />
            </Button>

            <AceEditor
                theme="monokai"
                mode='groovy'
                value={this.state.selectedResult}
                placeholder='selected transportOrder'
                width="100%"
                height="96%"
                readOnly={true}
            />
        </>
    }

    drawSplittedArea() {
        return <div style={{ width: '100%', height: '100%' }}>
            <Splitter
                name="MultiOrderScriptResultSplitter"
                left={this.drawTable()}
                right={this.drawSingleResultJson()}
            /></div>
    }

    fetchBefore() {
        let result = null
        if (this.state.selectedResult) {
            try {
                result = this.props.originalOrders.find((order) => order._id == JSON.parse(this.state.selectedResult)._id)
            } catch (e) {
                console.log("ERROR: cannot parse selected result or it doesn't have an '_id' ", e)
                result = "ERROR: cannot parse selected result or it doesn't have an '_id'. Check the logs!"
            }

        }
        return result
    }

    render() {
        return <>
            <div
                ref={this.containerRef}
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    height: 'calc(100vh - 150px)',
                    userSelect: this.state.isDragging ? 'none' : 'auto',
                }}
            >
                <div style={{ height: this.state.topHeight, flexShrink: 0, overflow: 'hidden' }}>
                    {this.drawSplittedArea()}
                </div>

                <div
                    onMouseDown={this.onDragStart}
                    style={{
                        height: 8,
                        cursor: 'row-resize',
                        background: this.state.isDragging ? '#bbb' : '#e0e0e0',
                        flexShrink: 0,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}
                >
                    <div style={{ width: 40, height: 2, background: '#999', borderRadius: 1 }} />
                </div>

                <div style={{ flex: 1, overflow: 'auto', paddingTop: 4 }}>
                    <h4 style={{ margin: '0 0 4px 0' }}>Logs:</h4>
                    <LogView
                        query={this.props.xRequestId}
                        origin={"scriptRunner"}
                        initialTimespan={null}
                        responseLogs={null}
                    />
                </div>
            </div>

            <IfBox shouldShow={this.state.showCompareModal}>
                <MultiOrderScriptResultCompareModal
                    isOpen={this.state.showCompareModal}
                    onClose={() => { this.setState({ showCompareModal: false }) }}
                    before={this.fetchBefore()}
                    after={this.state.selectedResult}
                />
            </IfBox>
        </>
    }
}